export default "__VITE_ASSET__BieyxPPY__"